const carouselItems = [
  {
    title: '娱乐圈六月吃瓜月报：顶流塌房、恋情曝光、综艺名场面',
    summary: '本月娱乐圈风云变幻，多位明星因私生活问题陷入舆论漩涡。从某顶流男星被拍到深夜约会，到一线女星突然宣布离婚，再到热门综艺录制现场爆发冲突……吃瓜群众表示瓜太多吃不过来。',
    tag: '月度盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20magazine%20cover%20illustration%20with%20warm%20coral%20red%20tones%2C%20featuring%20abstract%20entertainment%20news%20collage%20elements%2C%20dramatic%20spotlight%20effects%20on%20dark%20rich%20background%2C%20modern%20magazine%20layout%20aesthetic%20with%20artistic%20geometric%20accents%2C%20golden%20amber%20light%20streaks%20across%20the%20composition%2C%20no%20text%20no%20letters&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '网红直播带货乱象大盘点：从翻车到维权全记录',
    summary: '随着直播带货行业持续火爆，问题也层出不穷。从产品虚假宣传到售后维权困难，从价格欺诈到数据造假，多家知名主播接连翻车。本文梳理近期网红带货的典型案例与消费者维权路径。',
    tag: '深度报道',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20modern%20digital%20streaming%20studio%20with%20warm%20amber%20and%20coral%20lighting%2C%20abstract%20live%20commerce%20scene%20with%20floating%20product%20icons%20and%20data%20visualizations%2C%20editorial%20collage%20style%2C%20dark%20warm%20background%20with%20soft%20glowing%20accents%2C%20creative%20magazine%20spread%20aesthetic%2C%20no%20text%20no%20letters&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '影视剧"神改编"争议：原著粉与剧粉为何频频开撕',
    summary: '近期多部IP改编剧集引发原著粉丝强烈不满。从剧情魔改到角色OOC，从选角争议到结局大改，影视改编与原著之间的平衡再次成为热议话题。我们整理了近期争议最大的五部改编作品。',
    tag: '行业观察',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20showing%20a%20split%20screen%20concept%20with%20film%20reel%20on%20one%20side%20and%20open%20book%20on%20the%20other%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20creative%20editorial%20design%2C%20modern%20magazine%20aesthetic%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20dark%20rich%20background%2C%20no%20text%20no%20letters&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '社交媒体"社死"现场：那些年我们围观过的尴尬名场面',
    summary: '从朋友圈手滑点赞到微博切错号翻车，从微信工作群发错消息到直播忘记关摄像头……社交媒体时代的"社死"瞬间总能引发全网狂欢。本文回顾近期最具话题度的社交翻车事件。',
    tag: '吃瓜合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20illustration%20of%20overlapping%20smartphone%20screens%20floating%20in%20abstract%20digital%20space%2C%20warm%20coral%20and%20amber%20tones%2C%20artistic%20editorial%20collage%2C%20creative%20tech%20meets%20entertainment%20aesthetic%2C%20dark%20background%20with%20soft%20light%20streaks%2C%20no%20text%20no%20letters&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            深度梳理近期最受关注的吃瓜专题，一网打尽不遗漏
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}